import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import touchDevise from './lib/detectTouch';

const sectionNode = document.querySelector('.js-section-stage');
const sliderNode = document.querySelector('.js-stage-slider');
const slideNodes = [...sliderNode.querySelectorAll('.js-item')];

const getY = (x0, x1, x, min = 0, max = 1) => {
  return (-min*x + max*x - max*x0 + min*x1) / (x1 - x0);
}

const myLimit = (progress, zero1, center, zero2) => {
   if (progress <= zero1) {
     return 0
   } 
   if (progress <= center) {
    return getY(zero1, center, progress)
  } 
  if (progress <= zero2) {
    return getY(zero2, center, progress)
  }
  return 0
}

const myLimit2 = (progress, zero1, center1, center2, zero2) => {
  if (progress <= zero1) {
    return 0.5
  } 
  if (progress <= center1) {
   return getY(zero1, center1, progress, 0.5)
 } 
  if (progress > center1 && progress < center2) {
   return 1
 } 
 if (progress <= zero2) {
   return getY(zero2, center2, progress, 0.5)
 }
 return 0.5
}

const update = progress => {
  const scrollWidth = sliderNode.scrollWidth - window.innerWidth;
  let sumWidth = 0;
  const half = (window.innerWidth/2) / scrollWidth;

  const offset = (window.innerWidth/5) / scrollWidth;

  let data = `progress: ${progress}`;
  slideNodes.forEach((slide, i) => {
    const width = slide.offsetWidth / scrollWidth;

    const center = sumWidth + width/2 - half;
    const zero1 = center - half;    
    const center1 = center - half/2; 
    const center2 = center + half/2 ; 
    const zero2 = center + half ;
    
    sumWidth += width;
    data += 
    `
    -----
    zero1: ${zero1}
    center1: ${center1}
    center2: ${center2}
    zero2: ${zero2}
    `
    let opacity = myLimit2(progress, zero1, center1, center2, zero2);
    const img = slide.querySelector('img');

    if (
      progress >= center2 && i === slideNodes.length-1
      || progress <= center1 && i === 0
    ) {
      opacity = 1;
    }

    img.style.opacity = opacity;
  })
}

let tl;

const createTimeLine = () => {
  return gsap.timeline({
    scrollTrigger: {
      id: 'triggerStage',
      trigger: sectionNode,
      pin: true,
      scrub: 0,
      start: 'bottom bottom',
      scroller: '[data-scroll-container]',
      end: () => `+=${sliderNode.scrollWidth - window.innerWidth}`,
      // markers: true
    },
    onUpdate: () => { update(tl.progress()) }
  })
  .to(sliderNode, {
    x: () => `-=${sliderNode.scrollWidth - window.innerWidth}`,
    ease: 'none',
  }, 0)
}

const slider = {
  init: () => {
    tl = createTimeLine();
    update(0);
    ScrollTrigger.refresh();
  },
  resize: () => {
    if (ScrollTrigger.getById('triggerStage')) {
      const progress = tl.progress();
      gsap.set([sliderNode, sectionNode], {clearProps: 'all'});
      ScrollTrigger.getById('triggerStage').kill(true);
      tl = createTimeLine();
      update(progress);
      tl.progress(progress);
    }
    
  }
}

export default slider;